const form_submit_button_error =
  'Tienes artículos en tu carrito. Por favor paga y guarda si quieres guardar los cambios'

export default form_submit_button_error
